import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as chanceApi from '../../lib/api/chance';

const [LIST_PROJECT_COSTS, LIST_PROJECT_COSTS_SUCCESS, LIST_PROJECT_COSTS_FAILURE] =
  createRequestActionTypes('tech/LIST_PROJECT_COSTS');

export const listProjectCosts = createAction(LIST_PROJECT_COSTS, (id) => id);
const listProjectCostsSaga = createRequestSaga(
  LIST_PROJECT_COSTS,
  chanceApi.getCosts,
);

const UNLOAD_COSTS = 'tech/UNLOAD_COSTS';
export const unloadCosts = createAction(UNLOAD_COSTS);

export function* projectCostsSaga() {
  yield takeLatest(LIST_PROJECT_COSTS, listProjectCostsSaga);
}

const initialState = {
  costs: null,
  error: null,
};

const projectCosts = handleActions(
  {
    [LIST_PROJECT_COSTS_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      costs: data.list.map((cost) => ({
        id: cost.expUuid,
        expUuid: cost.expUuid,
        prjUuid: cost.prjUuid,
        productUuid: cost.productUuid,
        productNm:cost.productNm,
        priceUuid: cost.priceUuid,
        priceVal: cost.priceVal,
        expCnt: Number(cost.expCnt),
        saleVal: Number(cost.saleVal),
        saleValIn: Number(cost.saleValIn),
        salePct: cost.salePct,
        salePctIn: cost.salePctIn,
        buyVal:Number(cost.buyVal),
        partnerNm:cost.partnerNm,
        crtUsr:cost.crtUsr,
        crtNm: cost.crtNm,
        crtDt: cost.crtDt,
      })),
      error: null,
    }),
    [LIST_PROJECT_COSTS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_COSTS]: () => initialState,
  },
  initialState,
);

export default projectCosts;
